module.exports = __webpack_public_path__ + "827eaa559fa19a5e99a808e1a70d8c66.svg";


//////////////////
// WEBPACK FOOTER
// ./images/group-icon.svg
// module id = 69
// module chunks = 0